export default "__VITE_ASSET__5u1nbP$F__"